<template>
    <div class="card no-shadow m-l-12">
        <div class="card-content p-x-0 padding-top-0">
            <div class="content">
                <div class="column is-paddingless">
                    <div v-resultsCount="getItemsLength"></div>

                    <table class="table is-size-7-touch transparent-table">
                        <thead v-if="items.length">
                            <tr>
                                <td class="has-text-weight-bold has-text-centered tpad-32">
                                    <label class="checkbox label">
                                        <input type="checkbox" v-model="allSelected">
                                    </label>
                                </td>
                                <td class="is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey is-clearfix alias-name tpad-32">
                                    Alias business name
                                </td>
                                <td class="is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey is-clearfix">
                                    <div class="tpad-22 is-pulled-left">ID</div>
                                    <button @click="removeAlias" :disabled="!selectedAlias.length" class="button is-button-grey-outline is-button-medium is-pulled-right">REMOVE</button>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-if="items.length" v-for="(item,index) in items">
                            <td class="has-text-centered">
                                <label class="checkbox label">
                                    <input type="checkbox" v-model="selectedAlias" :value="item.id">
                                </label>
                            </td>

                            <td class="is-size-7-mobile is-size-7-desktop has-text-grey alias-name">
                                {{item.alias}}
                            </td>

                            <td class="is-size-7-mobile is-size-7-desktop has-text-grey">
                                {{item.id}}
                            </td>
                        </tr>
                        <tr v-if="items.length === 0">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey"
                                colspan="7">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <paginator :dataSet="dataSet" @changed="getBusinessAliases"></paginator>
        </div>
    </div>
    <!-- paginator -->

</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import misc from '../../mixins/misc.js'
  import axios from 'axios'
  import moment from 'moment'
  import Paginator from '../../components/Paginator.vue'

  export default {
    components: {
      Paginator
    },
    mixins: [misc],
    props: {
      businessName: {
        type: String
      }
    },
    data () {
      return {
        is_loading: true,
        fetching_reviews: false,
        items: [],
        dataSet: {},
        selectedAlias: []
      }
    },
    computed: {
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      },
      // get items count
      getItemsLength () {
        return this.items.length ? this.dataSet.total : 0
      },

        allSelected: {
          get: function () {
              return this.items.length ? this.selectedAlias.length === this.items.length : false
          },
            set: function (checked) {
              if (checked) {
                  const aliasIds = []
                  this.items.forEach((obj, index) => {
                      aliasIds.push(obj.id)
                  })
                  this.selectedAlias = aliasIds
              } else {
                  this.selectedAlias = []
              }
            }
        }
    },
    created () {
      this.getBusinessAliases(null)
    },

    methods: {
      authorDisplayName (name) {
        return name.replace(' ', '&nbsp;')
      },
      formatDate (dateString, dateFormat) {
        return moment(dateString).format(dateFormat)
      },
      /**
       * Makes an api call to get reviews for org
       * @param {number | null} page to return data from
       * @returns {void}
       */
      getBusinessAliases (page) {
        this.fetching_reviews = true
        axios.get(this.url(page))
            .then((reviews) => {
              this.fetching_reviews = false
              this.refresh(reviews, 'reviews')
              window.document.title = `Business Portal | Hellopeter - ${this.businessName} (Reviews)`
              this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: window.document.title
              })
              window.scrollTo(0, 0)
            })
            .catch(() => {
              parent.fetching_reviews = false
            })
      },
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }
        return `/business/${this.getBusinessSlug}/aliases?page=${page}`
      },
        /**
         * Remove alias from business
         * @returns {void}
         */
        removeAlias () {
            axios.delete(`/business/${this.getBusinessSlug}/aliases/${this.selectedAlias}`)
                .then(response => {
                    this.getBusinessAliases(null)
                    this.selectedAlias = []
                    const flashMsg = `Alias successfully removed.`
                    flash(flashMsg)
                    dataLayer.push({
                        'userMessage': {
                            'messageType': 'success',
                            'messageName': 'Successfully removed alias from business on Business Profile view',
                            'displayedMessage': flashMsg
                        }
                    })
                })
                .catch(() => {
                    const flashMsg = 'Error removing alias. Please try again later.'
                    flash(flashMsg, 'is-danger')
                    dataLayer.push({
                        'userMessage': {
                            'messageType': 'error',
                            'messageName': 'Failed to remove alias from business on Business Profile view',
                            'displayedMessage': flashMsg
                        }
                    })
                })
        }
    }
  }
</script>

<style scoped>
    .table .tpad-32{
        padding-top: 32px !important;
    }

    .table .tpad-22{
        padding-top: 22px !important;
    }

    .table td, .table th {
        border: none;
        padding: 0.7rem 0.75em !important;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    thead button{
        margin-right: 1.5rem;
    }

    tr > td:first-child {
        width: 45px;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    tr label.checkbox{
        padding-left: 15px;
        padding-right: 15px;
    }

    .alias-name {
        width: 30%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessAliases.vue